export default __webpack_public_path__ + "static/media/cel.f0416efd.png";